export default{
    franky: {},
    loading: false,
    error: ""
}